/**
 * Komponent status pill (kolorowe pilli dla statusów)
 */

import React, { FC, useMemo } from 'react';
import classnames from 'classnames';

import styles from 'theme/components/wise/WiseTable/components/StatusPill/StatusPill.module.scss';

type StatusVariant = 'active' | 'pending' | 'inactive';

interface IStatusPillProps {
  status: string;
  label?: string;
}

const STATUS_VARIANT_MAP: [StatusVariant, string[]][] = [
  [
    'inactive',
    [
      'nieaktywne',
      'nieaktywny',
      'zablokowane',
      'zaplanowane',
      'oczekujące',
      'otwarte',
      'inactive',
      'new'
    ]
  ],
  ['active', ['aktywny', 'aktywna', 'aktywne', 'w toku', 'active', '1', 'done']],
  ['pending', ['do weryfikacji', 'weryfikacja', 'pending', 'in_progress', '0']]
];

const getStatusVariant = (status: string): StatusVariant => {
  const value = status.toLowerCase().trim();

  return (
    STATUS_VARIANT_MAP.find(([, keywords]) =>
      keywords.some((k) => value.includes(k)))?.[0] ??
    'inactive'
  );
};

/**
 * Komponent status pill
 */
const StatusPill: FC<IStatusPillProps> = ({ status, label }) => {
  const variant = useMemo(() => getStatusVariant(status), [status]);
  const displayLabel = label ?? status;

  return (
    <span className={classnames(styles.componentWrapper, styles[variant], 'StatusPill')}>
      {displayLabel}
    </span>
  );
};

export default StatusPill;
